import { styled } from 'styled-components';
import { offsets, media, colors } from 'theme';
import { Button, P, Icon, H3 } from 'ui';

type StartMiningSectionProps = {
  $background: string;
};

export const StartMiningSection = styled.section<StartMiningSectionProps>`
  background-image: ${({ $background }) => `url(${$background})`};
  display: flex;
  flex-direction: column;
  background-color: ${colors.onBlack};
  align-items: center;
  gap: ${offsets.extraLarge};
  padding-bottom: ${offsets.sectionVertical};
`;

export const StartMiningTitle = styled(H3)`
  text-align: center;
  max-width: 44.375rem;
`;

export const StartMiningDescription = styled(P)`
  text-align: center;
  max-width: 30.5rem;
`;

export const PaddingContainer = styled.div`
  padding: ${offsets.sectionVertical} ${offsets.sectionHorizontal} 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${offsets.medium};

  @media (max-width: ${media.laptop}px) {
    padding: 80px 60px;
  }

  @media (max-width: ${media.tablet}px) {
    padding: 60px 40px;
  }

  @media (max-width: ${media.tablet}px) {
    padding: 60px 16px;
  }
`;

export const AsicCardWrapper = styled.article<{ $active?: boolean }>`
  cursor: pointer;
  position: relative;

  height: 19.313rem;
  padding: 2rem 1rem;
  border-radius: 0.75rem;
  border: 2px solid ${({ $active }) => ($active ? colors.yellow : '#ffffff20')};
  background: #ffffff01;
  backdrop-filter: blur(25px);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${offsets.medium};
  width: 100%;

  @media (max-width: ${media.mobile}px) {
    flex-direction: column;
    height: fit-content;
    padding: 1.25rem 0.75rem;
  }
`;

export const SwiperWrapper = styled.div`
  width: 100%;
  & .swiper {
    padding: 0 20px;
  }
  & .swiper-wrapper {
    align-items: center;
  }

  @media (max-width: ${media.mobile}px) {
    height: 580px;
  }
`;

export const AsicPreview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  justify-content: space-between;
  flex-grow: 1;

  @media (max-width: ${media.mobile}px) {
    gap: 0.75rem;
    width: 100%;
  }
`;

export const AsicTitle = styled(P)<{ $isVisible?: boolean }>`
  opacity: ${({ $isVisible }) => ($isVisible ? '1' : '0')};
  text-align: center;
  font-weight: 600;
  align-items: center;
`;

export const AsicCollection = styled(P)<{ $isVisible?: boolean }>`
  opacity: ${({ $isVisible }) => ($isVisible ? '1' : '0')};
  text-align: center;
  font-weight: 400;
  align-items: center;
  color: ${colors.grey};
  margin-top: 0.75rem;
`;

export const AttributeList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const AttributeItem = styled.li`
  display: flex;
  gap: 12px;
  align-items: center;
  & > p {
    font-weight: 600;
  }
`;

export const AttributeIcon = styled(Icon)`
  width: 24px;
  aspect-ratio: 1;
  color: ${colors.grey};
`;

export const TitleWrap = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const TitlePrimary = styled(P)`
  font-weight: 600;
`;

export const AsicImg = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin-bottom: 1.25rem;
  position: relative;
  z-index: 1;
  @media (max-width: ${media.tablet}px) {
    margin-bottom: 0;
  }
`;

export const SliderImgWrapper = styled.div`
  width: 299px;
  height: 224px;
`;

export const LeftWrap = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  transform: translateZ(0);
`;

export const BagIcon = styled(Icon)`
  width: 20px;
  height: 20px;
`;

export const AttributeButton = styled(Button.Link)`
  width: 100%;
  margin-right: 1rem;
  @media screen and (max-width: ${media.mobile}px) {
    margin-right: unset;
  }
`;
